import React from 'react'
import { Link } from 'react-router-dom'
import Heading from '../Heading'

import { motion } from "framer-motion";
import { Community_path } from '../../Data/E_Offer';
const Path = () => {
     const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                duration: 0.8
            }
        }
    };
  return (
        <motion.section 
            className="main-lwbl bg-[#F9FAFB] pt-16 pb-16 px-[0.5rem] overflow-hidden"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={containerVariants}
        >
           <Heading subHeading={"Simple, intentional ways to start connecting"}
             heading={"Path Into the Community"}
             detail={"Becoming part of the Lightweave community is a welcoming and easy process. Whether you start by posting your first showcase, joining a discussion, or participating in a challenge, every step brings you closer to a supportive network of creative peers."}
           />

           <div className='flex flex-wrap justify-center items-center gap-[20px] mt-[3rem]'>
              {Community_path.map((data,index)=>(
                 <div key={data.id} className='text-center'>
                    <h3 className='font-cinzel mb-[1rem] text-[30px] '>STEP {data.id}</h3>
                 <div
        className="group relative w-[290px] xs:w-[100%] min-h-[285px] flex flex-col items-center justify-center text-center gap-[1rem] rounded-2xl px-[1rem] py-[1.25rem] 
          transition-all duration-500 hover:scale-[1.04] 
          hover:-translate-y-2 hover:shadow-xl"
        style={{
          background:
            "linear-gradient(29deg, rgba(0, 240, 251, 1) 0%, rgba(255,255,255,1) 50%, rgba(0, 240, 251, 1) 100%)",
        }}
      > 
        <h2
          className="font-cinzel text-[25px] pt-2 pb-2 font-medium 
            transition-all duration-500 group-hover:tracking-wide"
        >
          {data.title}
        </h2>
         <p  className='text-[18px]'>
            {data.detail}
         </p>
         <Link
           to={data.path}
           className="mt-auto inline-flex rounded-full bg-neutral-900 px-5 py-2 font-outfit text-xs font-semibold uppercase tracking-[0.18em] text-white transition hover:bg-cyan-700"
         >
           {data.action}
         </Link>

       
      </div>
      </div>
              ))}
           </div>
       </motion.section>
  )
}

export default Path
